import { useDisclosure } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { TagEditorProps } from 'apps/TenantApp/components/tags/TagEditor';
import { TagModal } from 'apps/TenantApp/components/tags/TagModal';
import { TagIcon } from 'components/icons';
import { OptionsMenuItem } from 'components/OptionsMenu/OptionsMenuItem';
import React from 'react';
import { useFeatureFlag } from 'utils/sessionProvider';

export const AddTagsOption = (props: TagEditorProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const isRenameTagsEnabled = useFeatureFlag('FEATURE_RENAME_TAGS_TO_LABELS');

  return (
    <>
      <OptionsMenuItem icon={<TagIcon />} onClick={onOpen}>
        {isRenameTagsEnabled ? t`Labels` : t`Tags`}
      </OptionsMenuItem>

      <TagModal {...props} isOpen={isOpen} onClose={onClose} />
    </>
  );
};
